import { dynamicEnvironment } from "src/app/Common/DynamicEnvironment/DynamicEnvironment";
import { SocietyDTO } from "src/app/housing-society/Interface & Service/society/society.interface";
import { DocumentVerificationSessionDTO } from "src/app/Shared Utilities/documentVerificationSession/documentVerificationSession.interface";
import { environment } from "src/environment/environment";

export function documentUploadEmailToSocietyAdmin(
  societyInfo: SocietyDTO,
  documentVerificationSessionData: DocumentVerificationSessionDTO,
  sessionId: string,
  rejectReason: string,
) {
  function formatDate(dateString: string) {
    const date = new Date(dateString);

    const options: Intl.DateTimeFormatOptions = {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    };

    return date.toLocaleString("en-GB", options);
  }

  return `
  <!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8" />
  <meta name="viewport" content="width=device-width, initial-scale=1.0" />
  <title>Society Document Upload Request</title>
  <style>
    body {
      font-family: 'Segoe UI', Roboto, Arial, sans-serif;
      background: linear-gradient(135deg, #f4f1ff, #ffffff);
      color: #333;
      margin: 0;
      padding: 0;
    }
    .email-container {
      max-width: 700px;
      margin: 40px auto;
      background: #fff;
      border-radius: 12px;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
      overflow: hidden;
    }
    .header {
      background: linear-gradient(90deg, #5a3ef2, #a16eff);
      color: #fff;
      text-align: center;
      padding: 25px;
    }
    .header h1 {
      margin: 0;
      font-size: 24px;
      font-weight: 600;
    }
    .content {
      padding: 30px;
      line-height: 1.6;
    }
    .content h2 {
      color: #5a3ef2;
      font-size: 20px;
      margin-bottom: 10px;
    }
    .info-box {
      background: #f9f7ff;
      border-left: 4px solid #5a3ef2;
      padding: 15px;
      border-radius: 8px;
      margin-top: 20px;
    }
    .button {
      display: inline-block;
      margin-top: 20px;
      padding: 12px 24px;
      background-color: #5a3ef2;
      color: #fff;
      border-radius: 8px;
      text-decoration: none;
      font-weight: 500;
    }
    .footer {
      background: #f4f1ff;
      color: #666;
      text-align: center;
      font-size: 13px;
      padding: 15px;
    }
    ul {
      padding-left: 18px;
    }
  </style>
</head>

<body>
  <div class="email-container">
    <div class="header">
      <h1>Society Document Verification Required</h1>
    </div>

    <div class="content">
      <h2>Dear <strong>${societyInfo.societyName}</strong>,</h2>

      <p>
        Thank you for registering with the <strong>Nishwik Society Management System</strong>.
        To complete your onboarding and activate your society dashboard, we request you to
        upload the mandatory legal and compliance documents for verification.
      </p>

      <div class="info-box">
        <h3>Document Upload Request Details</h3>
        <p><strong>Request Raised On:</strong> ${formatDate(
          documentVerificationSessionData.generatedOn.toString(),
        )}</p>
        <p><strong>Expires On:</strong> ${formatDate(
          documentVerificationSessionData.expiresOn.toString(),
        )}</p>
        <p style="color:#a33;">
          ⚠️ Upload link valid for <strong>24 hours only</strong>.
        </p>
      </div>

      <div class="info-box">
        <h3>Documents Required for Verification</h3>
        <ul>
          <li><b>Society Registration Certificate</b></li>
          <li><b>PAN Card (Society)</b></li>
          <li><b>Approved Bye-Laws</b></li>
          <li><b>Address Proof</b></li>
          <li><b>Managing Committee List</b></li>
          <li><b>Bank Account Proof</b> <span style="color:#777;">(Optional)</span></li>
          <li><b>Occupancy / Completion Certificate</b> <span style="color:#777;">(Optional)</span></li>
        </ul>
      </div>

      <a href="${dynamicEnvironment.websiteURL}/society-document-upload/${sessionId}/${societyInfo.societyId}"
         class="button" style="color:white;">
        Upload Society Documents
      </a>

      <p><strong>Society Information:</strong></p>
      <ul>
        <li><b>Name:</b> ${societyInfo.societyName}</li>
        <li><b>Description:</b> ${societyInfo.societyDescription}</li>
        <li><b>Registration No:</b> ${societyInfo.registrationNumber}</li>
        <li><b>Address:</b> ${societyInfo.address}</li>
        <li><b>Location:</b> ${societyInfo.city}, ${societyInfo.state} - ${
          societyInfo.zipCode
        }</li>
        <li><b>Email:</b> ${societyInfo.contactEmail}</li>
        <li><b>Contact:</b> ${societyInfo.contactPhone}</li>
      </ul>

      <p>
        For any assistance, contact us at
        <a href="mailto:nishwikdev@gmail.com">nishwikdev@gmail.com</a>.
      </p>

      <p>
        Warm regards,<br/>
        <strong>The Nishwik Onboarding Team</strong>
      </p>
    </div>

    <div class="footer">
      © ${new Date().getFullYear()} Nishwik | All Rights Reserved
    </div>
  </div>
</body>
</html>
`;
}

export function onboardingSocietyDocumentUploadIssue(
  issue: string,
  societyInfo: SocietyDTO,
  userInfo: any,
) {
  return `
<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8" />
  <meta name="viewport" content="width=device-width, initial-scale=1.0" />
  <title>Society Document Upload Issue</title>
  <style>
    body {
      font-family: 'Segoe UI', Roboto, Arial, sans-serif;
      background: #ffffff;
      color: #333;
      margin: 0;
      padding: 0;
    }
    .email-container {
      max-width: 700px;
      margin: 30px auto;
      background: #fff;
      border-radius: 12px;
      border: 1px solid #eee;
      padding: 25px 30px;
    }
    h2 {
      color: #5a3ef2;
      margin-top: 0;
      font-size: 22px;
    }
    .box {
      background: #f8f5ff;
      border-left: 4px solid #5a3ef2;
      padding: 18px;
      border-radius: 8px;
      margin: 22px 0;
    }
    ul {
      padding-left: 18px;
    }
    li {
      margin: 6px 0;
    }
    .section-title {
      margin-top: 22px;
      font-size: 17px;
      color: #333;
    }
    .footer {
      margin-top: 30px;
      text-align: center;
      color: #888;
      font-size: 13px;
    }
  </style>
</head>

<body>
  <div class="email-container">
    <h2>Document Upload Issue Reported</h2>

    <p>Dear Team,</p>

    <p>
      A society has reported an issue while uploading onboarding documents.
      Please find the issue and sender details below for your review.
    </p>

    <div class="box">
      <h3 style="margin:0 0 10px;">📌 Reported Issue</h3>
      <p><strong>${issue}</strong></p>
    </div>

    <h3 class="section-title">👤 Reported By (User Details)</h3>
    <ul>
      <li><b>Name:</b> ${userInfo.userName}</li>
      <li><b>Email:</b> ${userInfo.email}</li>
      <li><b>Contact Number:</b> ${userInfo.contactNumber}</li>
    </ul>

    <h3 class="section-title">🏢 Society Information</h3>
    <ul>
      <li><b>Society Name:</b> ${societyInfo.societyName}</li>
      <li><b>Description:</b> ${societyInfo.societyDescription}</li>
      <li><b>Registration Number:</b> ${societyInfo.registrationNumber}</li>
      <li><b>Address:</b> ${societyInfo.address}</li>
      <li><b>City:</b> ${societyInfo.city}</li>
      <li><b>State:</b> ${societyInfo.state}</li>
      <li><b>Pincode:</b> ${societyInfo.zipCode}</li>
      <li><b>Email:</b> ${societyInfo.contactEmail}</li>
      <li><b>Contact Number:</b> ${societyInfo.contactPhone}</li>
    </ul>

    <p>
      Kindly review the issue and assist the society at the earliest.
      You may directly contact the user using the details provided above if needed.
    </p>

    <p>
      Regards,<br/>
      <strong>Nishwik Support System</strong>
    </p>

    <div class="footer">
      © ${new Date().getFullYear()} Nishwik | All Rights Reserved
    </div>
  </div>
</body>
</html>
`;
}

////////////////// ADD NEW //////////////

//  Re Send Rejected Document

// UPDATED: rejectReasons now accepts string[] to support multiple rejection reasons.
// A single string is also accepted (backwards compatible) — it will be treated as one reason.
export function documentRejectionEmailTemplate(
  societyInfo: SocietyDTO,
  documentVerificationSessionData: DocumentVerificationSessionDTO,
  rejectReasons: string | string[],
  sessionId: string,
) {
  function formatDate(dateString: string) {
    const date = new Date(dateString);

    const options: Intl.DateTimeFormatOptions = {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    };

    return date.toLocaleString("en-GB", options);
  }

  // Normalise to array — works whether caller passes a string or string[]
  const reasonsArray: string[] = Array.isArray(rejectReasons)
    ? rejectReasons.filter((r) => r && r.trim())
    : rejectReasons && rejectReasons.trim()
      ? [rejectReasons.trim()]
      : [];

  // Build the rejection reasons HTML block
  // - 0 reasons  → nothing rendered
  // - 1 reason   → single line  "Reason: <reason>"
  // - 2+ reasons → numbered list so each reason is clearly separated
  function buildReasonsBlock(): string {
    if (reasonsArray.length === 0) return "";

    if (reasonsArray.length === 1) {
      return `
        <div style="margin-bottom:12px; padding:10px 14px; background:#fff0f0; border-left:4px solid #d93025; border-radius:6px;">
          <strong style="color:#d93025;">Reason for Rejection:</strong>
          <p style="margin:6px 0 0; color:#333;">${reasonsArray[0]}</p>
        </div>`;
    }

    // Multiple reasons — render as a numbered list so each is clearly separated
    const items = reasonsArray
      .map(
        (r, i) =>
          `<li style="margin:6px 0; color:#333;"><strong>Rejection ${i + 1}:</strong> ${r}</li>`,
      )
      .join("");

    return `
      <div style="margin-bottom:12px; padding:10px 14px; background:#fff0f0; border-left:4px solid #d93025; border-radius:6px;">
        <strong style="color:#d93025;">Reasons for Rejection (${reasonsArray.length} documents rejected):</strong>
        <ol style="margin:8px 0 0; padding-left:18px;">
          ${items}
        </ol>
      </div>`;
  }

  return `
<!DOCTYPE html>

<html lang="en">
<head>
<meta charset="UTF-8" />
<meta name="viewport" content="width=device-width, initial-scale=1.0" />
<title>Socity Document Verification Failed</title>
<style>
body {
  font-family: 'Segoe UI', Roboto, Arial, sans-serif;
  background: linear-gradient(135deg, #fff4f4, #ffffff);
  color: #333;
  margin: 0;
  padding: 0;
}
.email-container {
  max-width: 700px;
  margin: 40px auto;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  overflow: hidden;
}
.header {
  background: linear-gradient(90deg, #d93025, #ff6b6b);
  color: #fff;
  text-align: center;
  padding: 25px;
}
.header h1 {
  margin: 0;
  font-size: 24px;
  font-weight: 600;
}
.content {
  padding: 30px;
  line-height: 1.6;
}
.content h2 {
  color: #d93025;
  font-size: 20px;
  margin-bottom: 10px;
}
.info-box {
  background: #fff5f5;
  border-left: 4px solid #d93025;
  padding: 15px;
  border-radius: 8px;
  margin-top: 20px;
}
.button {
  display: inline-block;
  margin-top: 20px;
  padding: 12px 24px;
  background-color: #d93025;
  color: #fff;
  border-radius: 8px;
  text-decoration: none;
  font-weight: 500;
}
.footer {
  background: #fff1f1;
  color: #666;
  text-align: center;
  font-size: 13px;
  padding: 15px;
}
ul {
  padding-left: 18px;
}
</style>
</head>

<body>
<div class="email-container">

<div class="header">
<h1>Document Verification Failed</h1>
</div>

<div class="content">

<h2>Dear <strong>${societyInfo.societyName}</strong>,</h2>

      ${buildReasonsBlock()}

<p>
Thank you for submitting your documents to the <strong>Nishwik Healthcare Management System</strong>.
After reviewing your uploaded files, our compliance team found issues with one or more documents.
Therefore, your Socity verification process <strong>could not be completed</strong>.
</p>

<div class="info-box">
<h3 style="margin:0 0 8px;">Verification Attempt Details</h3>
<p><strong>Reviewed On:</strong> ${formatDate(
    documentVerificationSessionData.generatedOn.toString(),
  )}</p>
<p><strong>Status:</strong> <span style="color:#d93025;font-weight:600;">Rejected</span></p>
<p style="margin-top:8px;">
You must correct and re-upload the rejected documents to continue onboarding.
</p>
</div>

<div class="info-box">
<h3 style="margin:0 0 8px;">Rejected Documents</h3>

<h4 style="color:#a33">Kindly use the "Re-Upload Documents" button below to review and re-upload the rejected documents.</h4>

<p style="margin-top:8px; color:black;">
Please ensure the documents are clear, valid, unexpired, and match Socity details before uploading again.
</p>
</div>

<p>You can re-upload the corrected documents using the secure link below:</p>

<a href="${dynamicEnvironment.websiteURL}/society-document-upload/${sessionId}/${societyInfo.societyName}" class="button" style="color:white;">
Re-Upload Documents
</a>

<p>
The link will remain valid for <strong>24 hours</strong>. After expiration, you must request a new upload link.
</p>

<p><strong>Socity Information:</strong></p>

<ul>
<li><b>Name:</b> ${societyInfo.societyName}</li>
<li><b>Address:</b> ${societyInfo.address}</li>
<li><b>City:</b> ${societyInfo.city}, ${societyInfo.state}</li>
<li><b>Email:</b> ${societyInfo.contactEmail}</li>
<li><b>Contact:</b> ${societyInfo.contactPhone}</li>
<li><b>Registration Number:</b> ${societyInfo.registrationNumber}</li>
</ul>

<p>
If you believe this rejection is incorrect or need assistance,
contact us at
<a href="mailto:suport@nishwik.com">suport@nishwik.com</a>.
</p>

<p>
We look forward to helping you successfully complete onboarding.
</p>

<p>
Regards,<br/>
<strong>Nishwik Compliance Team</strong><br/>
<small>Healthcare Verification Department</small>
</p>

</div>

<div class="footer">
© ${new Date().getFullYear()} Nishwik | All Rights Reserved
</div>

</div>
</body>
</html>

  `;
}
